import type { FunctionComponent } from 'react';
import { Text } from '@kanda-libs/ks-design-library';
import type { FinanceRate } from '@kanda-libs/ks-frontend-services';

import useCreditLines from './useCreditLines';
import CreditLine from './CreditLine';
import { CLASS_NAMES } from './constants';

const CreditLines: FunctionComponent = function () {
  const { creditLines, onClick, isLoading } = useCreditLines();

  return (
    <div className={CLASS_NAMES.wrapper}>
      <Text
        isLoading={isLoading}
        text="Loan Amount"
        className={CLASS_NAMES.heading}
      />
      <Text
        isLoading={isLoading}
        text="Choose which loan you wish to apply for."
        className={CLASS_NAMES.subHeading}
      />
      <div className={CLASS_NAMES.itemWrapper}>
        {creditLines.map((line: FinanceRate) => (
          <CreditLine
            financeOption={line}
            onClick={onClick}
            isLoading={isLoading}
            key={line.name}
          />
        ))}
      </div>
    </div>
  );
};

CreditLines.displayName = 'CreditLines-view';

export default CreditLines;
